import { z } from 'zod'

import { HotmartPurchaseProductFormat } from 'apps/externalTriggers/externalTriggerConstants'

export const hotmartProductSchema = z.object({
  name: z.string(),
  id: z.number(),
  format: z.enum(HotmartPurchaseProductFormat),
})

export const hotmartSchemas = {
  getProducts: {
    path: z.undefined(),
    query: z.object({
      format: z.enum(HotmartPurchaseProductFormat).optional(),
      id: z.string().optional(),
      page_token: z.string().optional(),
    }),
    request: z.undefined(),
    response: z.object({
      items: z.array(hotmartProductSchema).nullable(),
      page_info: z.object({
        next_page_token: z.string().nullable(),
      }),
    }),
  },
}

export type HotmartProductSchemaType = z.infer<typeof hotmartProductSchema>
